<div class="progress-container">
  <mat-progress-bar mode="indeterminate" *ngIf="isSaving$$ | async"></mat-progress-bar>
</div>
<h2 mat-dialog-title>Enter credit card</h2>
<mat-dialog-content>
  <form [formGroup]="formGroup">
    <glxy-form-field>
      <glxy-label>Name on card</glxy-label>
      <input
        matInput
        placeholder="Name on card"
        formControlName="cardholderName"
        value="{{ paymentCard ? paymentCard.cardholderName : '' }}"
        required
      />
    </glxy-form-field>
    <div class="fancy-card">
      <div class="card-data">
        <div class="card-number-container">
          <div class="field">
            <div class="input empty" id="card-number-element"></div>
            <label class="credit-card-label" for="card-number-element">Credit card number *</label>
            <div class="baseline"></div>
          </div>
        </div>
        <div class="row cvc-expiry-container">
          <div class="col cvc-expiry-container__item field">
            <div class="credit-card-input input empty" id="card-cvc-element"></div>
            <label class="credit-card-label" for="card-cvc-element">CVC *</label>
            <div class="baseline"></div>
          </div>
          <div class="col cvc-expiry-container__item field">
            <div class="credit-card-input input empty" id="card-expiry-element"></div>
            <label class="credit-card-label" for="card-expiry-element">Expiry *</label>
            <div class="baseline"></div>
          </div>
        </div>
      </div>
      <div class="error-container">
        <div class="card-cvc-error card-error"></div>
        <div class="card-expiry-error card-error"></div>
        <div class="card-number-error card-error"></div>
      </div>
      <div class="address-header">
        <div class="title">Billing address</div>
        <div class="option-group">
          <mat-checkbox formControlName="useContactAddress">Same as contact information</mat-checkbox>
        </div>
      </div>
      <ng-container *ngIf="showAddressFields()">
        <glxy-form-field>
          <glxy-label>Billing address</glxy-label>
          <input
            matInput
            placeholder="Billing address"
            formControlName="address"
            value="{{ paymentCard ? paymentCard.address : '' }}"
            required
          />
        </glxy-form-field>
        <glxy-form-field>
          <glxy-label>Country</glxy-label>
          <mat-select required placeholder="Country" [formControl]="formGroup.get('country')">
            <mat-option *ngFor="let country of countries$ | async" [value]="country.code">
              {{ country.name }}
            </mat-option>
          </mat-select>
        </glxy-form-field>
        <glxy-form-field>
          <glxy-label>City</glxy-label>
          <input
            matInput
            placeholder="City"
            formControlName="city"
            value="{{ paymentCard ? paymentCard.city : '' }}"
            required
          />
        </glxy-form-field>
        <glxy-form-field>
          <glxy-label>State/Province</glxy-label>
          <mat-select placeholder="State/Province" [formControl]="formGroup.get('state')" [required]="stateRequired">
            <mat-option *ngFor="let state of states$$ | async" [value]="state.code">
              {{ state.name }}
            </mat-option>
          </mat-select>
        </glxy-form-field>
        <glxy-form-field>
          <glxy-label>Zip/Postal code</glxy-label>
          <input
            matInput
            placeholder="Zip/Postal code"
            formControlName="zipCode"
            value="{{ paymentCard ? paymentCard.zipCode : '' }}"
            required
          />
        </glxy-form-field>
      </ng-container>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button color="primary" (click)="onClose(false)">Cancel</button>
  <button mat-raised-button color="primary" (click)="onSave()" [disabled]="isDisabled()">Save</button>
</mat-dialog-actions>
